import { render, staticRenderFns } from "./NeoBank.vue?vue&type=template&id=7625f89e&scoped=true&"
import script from "./NeoBank.vue?vue&type=script&lang=js&"
export * from "./NeoBank.vue?vue&type=script&lang=js&"
import style0 from "./NeoBank.vue?vue&type=style&index=0&id=7625f89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625f89e",
  null
  
)

export default component.exports